if (!customElements.get('pastael-logo-marquee')) {
  class PastaelLogoMarquee extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('[data-marquee-content]');
      if (!this.content) return;

      this.autoplay = this.dataset.autoplay !== 'false';
      this.speed = Number.parseFloat(this.dataset.speed) || 40;
      this.timing = this.dataset.timing || 'linear';

      this.content.style.setProperty('--marquee-timing', this.timing);
      this.ensureTrackCoverage();
      this.updateDuration();

      if (!this.autoplay) {
        this.content.style.animationPlayState = 'paused';
      }

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => {
          this.ensureTrackCoverage();
          this.updateDuration();
        });
        this.resizeObserver.observe(this);
      } else {
        window.addEventListener('resize', this.handleResize.bind(this));
      }

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => {
          this.ensureTrackCoverage();
          this.updateDuration();
        });
      }
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    handleResize() {
      this.ensureTrackCoverage();
      this.updateDuration();
    }

    ensureTrackCoverage() {
      const tracks = this.querySelectorAll('.pastael-hero-banner__marquee-track');
      if (!tracks.length) return;

      const containerWidth = this.clientWidth;
      if (!containerWidth) return;

      const minTrackWidth = containerWidth * 2;

      tracks.forEach((track) => {
        if (!track.dataset.baseHtml) {
          track.dataset.baseHtml = track.innerHTML;
        }

        const baseHtml = track.dataset.baseHtml;
        track.innerHTML = baseHtml;

        let safety = 0;

        while (track.scrollWidth < minTrackWidth && safety < 20) {
          track.insertAdjacentHTML('beforeend', baseHtml);
          safety += 1;
        }
      });
    }

    updateDuration() {
      if (!this.content) return;

      const trackWidth = this.content.scrollWidth / 2;
      if (!trackWidth) return;

      const duration = Math.max(trackWidth / this.speed, 1);
      this.content.style.setProperty('--marquee-duration', `${duration}s`);
    }
  }

  customElements.define('pastael-logo-marquee', PastaelLogoMarquee);
}
